import React, { useState, useEffect } from "react";
import SideBar from "../../../components/sidebar";
import Header from "../../../components/header";
import "../../../assets/CSS/dashboard.css";
import "../../../assets/CSS/forms.css";
import API_BASE_URL from "../../../config";
import LetterReportTable from "./letter-report-table";

function LetterReport() {
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [report, setReport] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (!query) {
      setSuggestions([]);
      return;
    }

    const delayDebounce = setTimeout(() => {
      fetch(`${API_BASE_URL}/api/letter-options?query=${query}`)
        .then((res) => res.json())
        .then((data) => {
          setSuggestions(data.letters.map((d) => d.letter));
        })
        .catch((err) => console.error("Error fetching:", err));
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [query]);

  const handleInput = (e) => {
    setQuery(e.target.value);
    setReport(false);
    setButtonClicked(false);
  };

  return (
    <div>
      {loader && (
        <div className="loader">
          <div className="loader-spinner"></div>
        </div>
      )}
      <SideBar />
      <div className="main-content">
        <Header />

        <div id="form-content">
          <div id="form-header" style={{ textTransform: "uppercase" }}>
            <p>Letter Number Wise Report</p>
          </div>
          <hr />
          <form id="form">
            <div id="form-input">
              <label>
                Letter Number<span className="required">*</span>
              </label>
              <input
                type="text"
                name="letter"
                autoComplete="off"
                placeholder="Select Letter Number"
                list="letter-options"
                value={query}
                onChange={(e) => handleInput(e)}
                required
              />
              <datalist id="letter-options">
                {suggestions.map((option, index) => (
                  <option key={index} value={option} />
                ))}
              </datalist>
            </div>
          </form>
          <div className="button">
            <button
              type="button"
              className="btn"
              id="search"
              onClick={() => {
                setReport(true);
                setLoader(true);
                setButtonClicked(true);
              }}
              disabled={buttonClicked}
            >
              SEARCH
            </button>
          </div>
        </div>
        {report && <LetterReportTable letter={query} setLoader={setLoader} />}
      </div>
    </div>
  );
}
export default LetterReport;
